import { useEffect } from 'react';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

const GoogleAnalytics = () => {
  useEffect(() => {
    let loaded = false;
    const loadGtag = () => {
      if (loaded) return;
      loaded = true;
      const script1 = document.createElement('script');
      script1.async = true;
      script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-XH6E9DB3D7';
      document.head.appendChild(script1);

      window.dataLayer = window.dataLayer || [];
      function gtag(...args: any[]) {
        window.dataLayer.push(args);
      }
      gtag('js', new Date());
      gtag('config', 'G-XH6E9DB3D7');
    };

    // Charger gtag au premier clic/scroll pour maximiser les économies LCP
    const events = ['click', 'scroll', 'keydown', 'touchstart'];
    const loadOnInteraction = () => {
      events.forEach((e) => document.removeEventListener(e, loadOnInteraction));
      loadGtag();
    };
    events.forEach((e) => document.addEventListener(e, loadOnInteraction, { once: true, passive: true }));

    // Fallback : charger après 8s si pas d'interaction
    const fallbackId = setTimeout(loadGtag, 8000);

    return () => {
      clearTimeout(fallbackId);
      events.forEach((e) => document.removeEventListener(e, loadOnInteraction));
      const script = document.querySelector('script[src*="googletagmanager.com/gtag/js"]');
      if (script) document.head.removeChild(script);
    };
  }, []);

  return null;
};

export default GoogleAnalytics;